import React from 'react';

const UniSpaceField = (props) => {
  let params = {};
  if (props.params) {
    params = props.params;
  }

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  let cl = 'uniformcompo__field uniformcompo__field--space-field' + extraClass;

  let style = {};
  if (params.w > 0) {
    style = {
      width: params.w
    };
  }

  return (
    <div className={cl} style={style}></div>
  );
};

export default UniSpaceField;